import Button, { BUTTON_HEIGHT_24 } from '../../../../../Button'

import * as styles from '../ApplicantCreditCheckBlock.module.css'

import ChevronCollapseIcon from '../../../../../../icons/chevron-collapse.svg'
import ChevronExpandIcon from '../../../../../../icons/chevron-expand.svg'

function ApplicantCreditCheckDisclosure({
  children,
  isOpen,
  qaName,
  text,
  onToggle,
}) {
  return (
    <div className={styles.disclosure}>
      <Button.Text
        beforeIconProps={{
          Icon: isOpen ? ChevronCollapseIcon : ChevronExpandIcon,
        }}
        className={styles.disclosureToggle}
        height={BUTTON_HEIGHT_24}
        qaName={qaName}
        text={text}
        onClick={onToggle}
      />
      {isOpen ? <div className={styles.disclosureItems}>{children}</div> : null}
    </div>
  )
}

export default ApplicantCreditCheckDisclosure
